const WritingData = {
  "The University’s next permanent president": [
    {
        link: "https://www.columbiaspectator.com/news/2026/01/25/columbia-selects-university-of-wisconsin-madison-chancellor-jennifer-mnookin-as-next-university-president-according-to-reports/",
        title: "Columbia selects University of Wisconsin-Madison Chancellor Jennifer Mnookin as next University president",
        author: "Emily Pickering and Spencer Davis",
        img: "https://www.columbiaspectator.com/resizer/v2/DZJBOWTLQFGH5GLSNPLNLO6LBM.jpg?auth=c39df7bb11b0dbcc34dbb7ec3fa3fba258ab9b87056ac5b5f99ef3bddbe93c96"
    },
    {
        link: "https://www.columbiaspectator.com/news/2026/01/26/what-to-know-about-jennifer-mnookin-columbias-next-president/",
        title: "What to know about Jennifer Mnookin, Columbia’s next president",
        author: "Pedro Meerbaum and Celine Chien",
        img: "https://www.columbiaspectator.com/resizer/v2/AEFD5AYTBBAO3LLVXLDDGEUGYY.jpg?auth=0eab8ec714480eb32faa5317fc5bb5c4d6388a63c7e19f4fb9f83a12a1e27697"
    },
    {
        link: "https://www.columbiaspectator.com/news/2026/01/26/a-different-start-students-react-with-hope-concerns-and-curiosity-to-incoming-university-president-jennifer-mnookin/",
        title: "‘A different start’: Students react with hope, concern, and curiosity to incoming University President Jennifer Mnookin",
        author: "Ashley Flores and Colette Carbonara",
        img: "https://www.columbiaspectator.com/resizer/v2/DN4DKF5VLJFJNJ2HX4AGQDXZFE.jpg?auth=91cc3dab991499695c027191c6c487fe0752147e3ec3e00742eb0705d0c6a9e5"
    },
    {
        link: "https://www.columbiaspectator.com/news/2026/01/26/jennifer-mnookin-pens-first-email-to-columbia-community-following-selection-as-next-university-president/",
        title: "Jennifer Mnookin pens first email to Columbia community following selection as next University president",
        author: "Spencer Davis and Theresa Cullen",
        img: "https://www.columbiaspectator.com/resizer/v2/U667ZX75ZFBKHDQNWL7WQEPWIY.jpg?auth=51d686c344171f4ebce04a663000ad8deba52db9c406e69a5a41bf4a2d83e16a"
    },
    {
        link: "https://www.columbiaspectator.com/news/2026/01/28/very-exciting-news-faculty-react-to-mnookins-appointment-with-relief-caution-and-hopes-for-renewed-unity/",
        title: "‘Very exciting news’: Faculty react to Mnookin’s appointment with relief, caution, and hopes for renewed unity",
        author: "Matt Luo and Shea Vance",
        img: "https://www.columbiaspectator.com/resizer/v2/FSQLC7GTDJCM3PL2QJUKPU6TRI.jpg?auth=77d689aa151c95ff0d3ccea8bba8ae097c821d2a2b19ff499e51320c3f73ead7"
    },
    {
        link: "https://www.columbiaspectator.com/news/2026/02/01/columbia-alumni-express-hope-for-stability-under-next-permanent-president-jennifer-mnookin/",
        title: "Columbia alumni express hope for stability under next permanent president Jennifer Mnookin",
        author: "Ushoshi Das and Shea Vance ",
        img: "https://www.columbiaspectator.com/resizer/v2/XTBBAMSZ7JBBNJBZJ2ENRXEMVY.jpg?auth=0b2cfd9acceaaa9decf63afc618551c29de2aff84a02db1998abff1d46c535db"
    },
    {
        link: "https://www.columbiaspectator.com/news/2026/02/05/mnookins-appointment-ends-a-2-year-period-of-interim-leadership-what-did-her-predecessors-leave-her/",
        title: "Mnookin’s appointment ends a 2-year period of interim leadership. What did her predecessors leave her?",
        author: "Joseph Zuloaga and Nadia Knoblauch ",
        img: "https://cloudfront-us-east-1.images.arcpublishing.com/spectator/YGIKQKCC3VETTMDL3CD47LK4MM.png"
    },
    {
        link: "https://www.columbiaspectator.com/news/2026/02/04/columbia-welcomes-mnookin-at-exclusive-event/",
        title: "Columbia welcomes Mnookin at exclusive event",
        author: "Spencer Davis and Colette Carbonara",
        img: "https://www.columbiaspectator.com/resizer/v2/2TQI4NSRFJDRNJSIP6ZQ3MAZHI.jpg?auth=beabe096f59ce4c8fbe341fd918347d302d1a88af25ab0ebfc94f440b5322b01"
    },
    {
        link: "https://www.columbiaspectator.com/news/2026/02/09/after-years-of-turmoil-columbia-looks-to-stabilize-with-a-new-president/",
        title: "After years of turmoil, Columbia looks to stabilize with a new president",
        author: "Shea Vance",
        img: "https://www.columbiaspectator.com/resizer/v2/XI5IS6DYQVF27PFNDYYROKIU2U.jpg?auth=09963902a54b5416fc0a0a8e32595e4f76721d8a6e91f6b5aa9dd10bb4630fe9"
    },
    ],
    "The Presidential Turnover": [
    {
        link: "https://www.columbiaspectator.com/news/2022/04/14/after-two-decades-as-president-bollinger-to-step-down-in-2023/",
        title: "After two decades as president, Bollinger to step down in 2023",
        author: "Irie Sentner",
        img: "https://cloudfront-us-east-1.images.arcpublishing.com/spectator/M6IOD2JQRZFNVNZJWNVGWZ65TI.png"
    },
    {
        link: "https://www.columbiaspectator.com/news/2023/01/18/meet-shafik-columbias-next-university-president/",
        title: "Meet Shafik, Columbia’s next University president",
        author: "Esha Karam, Rebecca Massel, and Sabrina Ticer-Wurr",
        img: "https://cloudfront-us-east-1.images.arcpublishing.com/spectator/BLD7VRT4JZHXLCQ2ZKEVEEUURQ.jpeg"
    },
    {
        link: "https://www.columbiaspectator.com/news/2024/08/14/shafik-resigns-from-presidency/",
        title: "Columbia President Minouche Shafik resigns amid campus turmoil over war in Gaza",
        author: "Sarah Huddleston, Shea Vance",
        img: "https://www.columbiaspectator.com/resizer/v2/V3WOLHFBVRBPLLWD3RLCBPKGJI.jpg?auth=4404429dee696ae98481ac09f9260b312400af4de62b85c3f2a9d15e6979959a"
    },
    {
        link: "https://www.columbiaspectator.com/news/2024/08/20/shafiks-columbia-13-months-and-13-days-of-a-campus-spiraling-into-crisis/",
        title: "Shafik’s Columbia: 13 months and 13 days of a campus spiraling into crisis",
        author: "Sarah Huddleston, Shea Vance",
        img: "https://cloudfront-us-east-1.images.arcpublishing.com/spectator/IM4QOFONKRG63CCOSPHFHOZSSI.jpg"
    },
    {
        link: "https://www.columbiaspectator.com/news/2024/08/15/what-to-know-about-katrina-armstrong-columbias-new-interim-president/",
        title: "What to know about Katrina Armstrong, Columbia’s new interim president",
        author: "Shea Vance, Sarah Huddleston",
        img: "https://www.columbiaspectator.com/resizer/v2/ECKMWVVQFVDKPNOBYAPT62DTOA.jpg?auth=fdf96988fea23d1c319b8e6ac54b3bfb6eff6e551fd6eacee886f5f6f302541f"
    },
    {
        link: "https://www.columbiaspectator.com/news/2024/08/17/as-shafiks-legacy-looms-armstrong-faces-a-tumultuous-road-ahead/",
        title: "As Shafik’s legacy looms, Armstrong faces a tumultuous road ahead",
        author: "Emily Forgash, Joseph Zuloaga",
        img: "https://cloudfront-us-east-1.images.arcpublishing.com/spectator/XWQ7KMOKCRFMFMTUSPTJWIYM4E.jpg"
    },
    {
        link: "https://www.columbiaspectator.com/news/2024/09/19/armstrong-discusses-campus-access-public-safety-and-community-engagement-in-first-interview/",
        title: "Armstrong discusses campus access, Public Safety, and community engagement in first interview",
        author: "Sarah Huddleston, Esha Karam, and Shea Vance",
        img: "https://www.columbiaspectator.com/resizer/v2/SRGVQ57EVFGKXI2JZFKO2URSFE.jpg?auth=4d89f381639f8b2c033c70e765c12f84fb9a3e8c23723cc018ba0462595f1a16"
    },
    {
        link: "https://www.columbiaspectator.com/news/2024/09/19/im-really-sorry-armstrong-apologizes-to-those-hurt-by-nypd-sweeps/",
        title: "‘I’m really sorry’: Armstrong apologizes to those ‘hurt’ by NYPD sweeps",
        author: "Esha Karam, Shea Vance, and Sarah Huddleston",
        img: "https://www.columbiaspectator.com/resizer/v2/7RMVPG44IVBEFKSOIVSQABWZ3I.JPG?auth=3283ce18921bac2ae35ba7e67c83e193f78a77df79b6dcc94a7dda1b2d69c415"
    },
    {
        link: "https://www.columbiaspectator.com/news/2025/03/28/armstrong-steps-down-as-interim-columbia-president-shipman-to-assumes-presidency/",
        title: "Armstrong steps down as interim Columbia president, Shipman assumes presidency",
        author: "Isha Banerjee",
        img: "https://www.columbiaspectator.com/resizer/v2/HABTANSZWJGOBFXQP5BESI4UD4.jpg?auth=20b2335af4bd08f3119af1b462d1bafc1f721e6b014047cc21e9bf86a5318455"
    },
    {
        link: "https://www.columbiaspectator.com/news/2025/04/09/federal-government-questioned-armstrong-over-campus-antisemitism-on-april-1-according-to-leaked-transcript/",
        title: "Federal government deposed Armstrong over campus antisemitism, according to leaked transcript",
        author: "Spencer Davis and Emily Pickering",
        img: "https://www.columbiaspectator.com/resizer/v2/JBMAUKOPR5FX7AZANRHB63XX6E.JPG?auth=7d3dcce99cf9d9e506f20738ad5b3e597cdc13b45914ef2ec2e7a1189ef2600d"
    },
    {
        link: "https://www.columbiaspectator.com/news/2025/04/03/a-fraught-beginning-and-a-sudden-end-seven-months-of-armstrong/",
        title: "A fraught beginning and a sudden end: Seven months of Armstrong",
        author: "Joseph Zuloaga, Emily Pickering",
        img: "https://cloudfront-us-east-1.images.arcpublishing.com/spectator/PS7ESOHUG5EVPIL6TYBRBQD7XA.png"
    },
    {
        link: "https://www.columbiaspectator.com/news/2025/04/02/the-institution-is-clearly-adrift-six-faculty-members-react-to-armstrong-stepping-down/",
        title: "‘The institution is clearly adrift’: Six faculty members react to Armstrong stepping down",
        author: "Nadia Knoblauch and Emily Pickering",
        img: "https://www.columbiaspectator.com/resizer/v2/5IHG5S2NPVCAJMOEXYLG5QOIH4.JPG?auth=22d483e0c1a472d199e8482e7d9b9810ee88a0ce5861f0e5d8849016d9b1a5d1"
    },
    {
        link: "https://www.columbiaspectator.com/news/2025/03/29/heres-what-to-know-about-claire-shipman-columbias-new-acting-president/",
        title: "Here’s what to know about Claire Shipman, Columbia’s new acting president",
        author: "Spencer Davis, Joseph Zuloaga, Molly Bordoff, and Aleka Gomez-Sotomayor-Roel",
        img: "https://www.columbiaspectator.com/resizer/v2/UUFPHLSBLFB6BJ5GZMRFR4EZHQ.JPEG?auth=291ef08ea4079fb14d4d76632996c20c4d4d5bf4164003231493b3e075331bc1"
    },
    {
        link: "https://www.columbiaspectator.com/news/2025/05/08/shipman-praises-nypd-and-public-safety-professionalism-after-butler-library-arrests/",
        title: "Shipman praises NYPD and Public Safety ‘professionalism’ after Butler Library arrests",
        author: "Spencer Davis and Joseph Zuloaga",
        img: "https://www.columbiaspectator.com/resizer/v2/O4UH5YHPIFFZBGRRRTGE67BBJU.jpg?auth=c046c46e2ed7db43921468c6f6506c049592c28757bcab39a1885d024e6ca9b2"
    },
    {
        link: "https://www.columbiaspectator.com/news/2025/06/14/mahmoud-khalil-met-with-shipman-to-discuss-palestinian-student-safety-over-a-year-before-ice-detainment-according-to-emails/",
        title: "Mahmoud Khalil met with Shipman to discuss Palestinian student safety over a year before ICE detainment, according to emails",
        author: "Emily Pickering",
        img: "https://www.columbiaspectator.com/resizer/v2/JQNT2GBCQBCZ7NAW6ZQMJBTKRE.jpg?auth=28fa1bd8ac6770339bddc2ba9c14dc900925db4d83f2bc6ef73f5fad0d447c03"
    },
    {
        link: "https://www.columbiaspectator.com/news/2025/07/23/in-line-with-our-values-shipman-describes-deal-with-trump-administration-in-first-interview-with-spectator/",
        title: "‘In line with our values’: Shipman describes deal with Trump administration in first interview with Spectator",
        author: "Isha Banerjee and Tsehai Alfred",
        img: "https://www.columbiaspectator.com/resizer/v2/ACXYPZQ4MNBMPOTD5IWCQI3SVQ.jpg?auth=71ca1dc580e64c1cc78327f2db0e6cdc1b1002c98e954b0cbddf90dc9dddcec9"
    },
    {
        link: "https://www.columbiaspectator.com/news/2025/12/23/during-final-university-senate-plenary-of-2025-shipman-says-improvements-to-campus-climate-and-morale-must-be-bottom-up/#:~:text=Acting%20University%20President%20Claire%20Shipman%2C%20CC%20'86%2C,and%20student%20senators%20for%20roughly%2045%20minutes.",
        title: "During final University Senate plenary of 2025, Shipman says improvements to campus climate and morale must be bottom-up",
        author: "Shea Vance",
        img: "https://www.columbiaspectator.com/resizer/v2/4U7VNOGAWNB7BHZYNQZ2C6ZWVY.jpg?auth=cf4718e4db65ce086375d0e8053cd94015ae782a4b71c77e8333ba561ed40404"
    },
    {
        link: "https://www.columbiaspectator.com/news/2026/01/21/bollinger-calls-for-universities-to-take-collective-action-against-trump-administration-in-first-post-presidency-spectator-interview/",
        title: "Bollinger calls for universities to take ‘collective action’ against Trump administration in first post-presidency Spectator interview",
        author: "Joseph Zuloaga, Matt Luo, and Spencer Davis",
        img: "https://www.columbiaspectator.com/resizer/v2/K4BXTVNMHJDSJOHF2EW347LU4I.JPG?auth=e3a1a0db72ff16aa5267e28f7996fea11749ec858145223359574d1683c16624"
    }
  ],
  // city: [
  //   {
  //     title:
  //       "Bollinger’s tenure accentuated a contentious, decades-long history between Columbia and West Harlem, some residents say",
  //     link: "https://www.columbiaspectator.com/city-news/2023/01/19/bollingers-tenure-accentuated-a-contentious-decades-long-history-between-columbia-and-west-harlem-some-residents-say/",
  //     author: "Isha Banerjee, Amira Mckee, and Esther Sun",
  //     img: "https://cloudfront-us-east-1.images.arcpublishing.com/spectator/JXNXQU4YCVFRPCNKQRORROX3HM.jpg",
  //     type:"left"
  //   }
  // ],
  // opinion: [
  //   {
  //     title:
  //       "So the University president-elect is a baroness. What now?",
  //     link: "https://www.columbiaspectator.com/opinion/2023/01/18/so-the-university-president-elect-is-a-baroness-what-now/",
  //     author: "Liam Etti",
  //     img: "https://cloudfront-us-east-1.images.arcpublishing.com/spectator/LBDAZSQ4VVB2ZELXCUVTMGN7MY.jpg",
  //     type:"normal"
  //   },
  //   {
  //     title:
  //       "President Shafik’s tenure could strengthen Columbia’s tradition of anticolonialism",
  //     link: "https://www.columbiaspectator.com/opinion/2023/01/18/president-shafiks-tenure-could-strengthen-columbias-tradition-of-anticolonialism/",
  //     author: "HD Wright",
  //     img: "https://cloudfront-us-east-1.images.arcpublishing.com/spectator/QYKXTO25OJCKFPMRDL7HXLWTCQ.jpg",
  //     type:"normal"
  //   },
  //   {
  //     title:
  //       "On transitions",
  //     link: "https://www.columbiaspectator.com/opinion/2023/01/19/on-transitions/",
  //     author: "Dhananjay Jagannathan",
  //     img: "https://cloudfront-us-east-1.images.arcpublishing.com/spectator/3QR6BPBJ5JBM5LUUZFS66C42KM.jpeg",
  //     type:"normal"
  //   },
  //   {
  //     title:
  //       "New president, same exploitative institution",
  //     link: "https://www.columbiaspectator.com/opinion/2023/01/19/new-president-same-exploitative-institution/",
  //     author: "Paul Brown, Claire Warner, and Nadeem Mansour",
  //     img: "https://cloudfront-us-east-1.images.arcpublishing.com/spectator/SKAQO7VCSZB6LNCI6OAJWYTT5Q.jpg",
  //     type:"normal"
  //   },
  //   {
  //     title:
  //       "Can Nemat Shafik bring a new social contract to Columbia?",
  //     link: "https://www.columbiaspectator.com/opinion/2023/01/19/can-nemat-shafik-bring-a-new-social-contract-to-columbia/",
  //     author: "Jonas Du",
  //     img: "https://cloudfront-us-east-1.images.arcpublishing.com/spectator/A3FG27PSMRDITOQXJTSQO3VAVQ.jpg",
  //     type:"normal"
  //   },
  //   {
  //     title:
  //       "Why it matters that our new president is a baroness",
  //     link: "https://www.columbiaspectator.com/opinion/2023/01/19/why-it-matters-that-our-new-president-is-a-baroness/",
  //     author: "James Tsukada",
  //     img: "https://cloudfront-us-east-1.images.arcpublishing.com/spectator/TN77PNEAA5CGLNJDMUGIJ6LH6Q.jpg",
  //     type:"normal"
  //   },
  // ],
  // photo: [
  //   {
  //     title:
  //       "In a ‘Lighter Equals Faster’ Culture, Runners Must Combat a Culture of Disordered Eating",
  //     link: "https://www.columbiaspectator.com/the-eye/2021/02/10/in-a-lighter-equals-faster-culture-runners-must-combat-a-culture-of-disordered-eating/",
  //     author: "Jade Justice and Elizabeth Karpen",
  //     img: "https://cloudfront-us-east-1.images.arcpublishing.com/spectator/EBNTW5T7JFHHHFME4GD5DBO6Y4.gif",
  //     type: "normal"
  //   },
  //   {
  //     title:
  //       "Bold and Brazen: Celebrating art and mental health as a Black student-athlete",
  //     link: "https://www.columbiaspectator.com/sports/2021/02/15/bold-and-brazen-celebrating-art-and-mental-health-as-a-black-student-athlete/",
  //     author: "Clara Ence Morse",
  //     img: "https://cloudfront-us-east-1.images.arcpublishing.com/spectator/MKIV52ONRBGVPJ2YSHPB5FDTTU.jpg",
  //     type: "normal"
  //   },
  // ],
  // photo: [
  //   {
  //     title:
  //       "Nemat “Minouche” Shafik announced Columbia’s 20th president, in pictures",
  //     link: "https://www.columbiaspectator.com/photo-essays/2023/01/18/nemat-minouche-shafik-announced-columbias-20th-president-in-pictures/",
  //     author: "Andrew Park, Judy Goldstein, Pippa Tsuki Carlson, and Jessica Samudio",
  //     img: "https://spectator-static-assets.s3.amazonaws.com/photo-essay-chief/P1011819.eee62854.jpg",
  //     type: "left"
  //   }
  // ]
};

export default WritingData;

